import PuxTabMixin from "../PuxTabMixin";

// @vue/component
export default {
  name: "PuxTabContent",
  mixins: [
    PuxTabMixin,
  ],
};
